module.exports = __webpack_public_path__ + "img/toggle2-on.254eaf92.svg";